import React from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';
import format from 'date-fns/format';
import { store } from '@quiqupltd/quiqupjs';
import { isMobile } from '@quiqupltd/qu-react-sdk/lib/utils/browser';
import { Container, Header, LottieContainer, Content, Icon, RateHeader } from './styles';
import { RateDelivery } from './rate-delivery/rate-delivery';
import { RateExperience } from '../rate-experience/rate-experience';
import { RateThankYou } from '../rate-experience/rate-thankyou';
import * as orderArrivedData from '../../../../animations/orderarrived.json';
import { PICKUP, DROPOFF, RETURN } from '../../../../utils/constants';
import { useRate } from '../../../../providers/rate.provider';

const defaultOptions = {
  loop: false,
  autoplay: true,
  animationData: orderArrivedData,
};

const TITLE = {
  pickup: 'Your order has been collected',
  dropoff: 'Your order has been delivered',
  return: 'Your driver has returned',
};

const SUBTITLE = {
  pickup: 'Collected',
  dropoff: 'Delivered',
  return: 'Driver returned',
};

const CompletedCardBody = ({ date, onToggleOpenCard, type, orderId, kind, companyName }) => {
  const [isRateOpen, setIsRateOpen] = useRate();

  const handleRateClick = () => {
    setIsRateOpen(true);
  };

  const toggleCardOpen = () => {
    onToggleOpenCard();
    setIsRateOpen(false);
  };

  const handleRatingFormSubmit = ({ packageCondition, deliveryTime, courier, notes }) => {
    return window
      .fetch(window.env.RATING_SHEET_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          date: new Date().toGMTString(),
          order_id: orderId,
          kind,
          company_name: companyName,
          package_condition_rating: packageCondition,
          courier_rating: courier,
          delivery_time_rating: deliveryTime,
          notes_rating: notes,
        }),
      })
      .then(() => {
        store.add(`rated-${orderId}`, true);
        setIsRateOpen(false);
      });
  };

  const hasAlreadyRated = store.get(`rated-${orderId}`);

  if (isRateOpen && !hasAlreadyRated) {
    return (
      <Container>
        {isMobile() && <Icon icon="chevron-down" width={20} height={20} onClick={toggleCardOpen} />}
        <div>
          <RateHeader>Rate your delivery experience</RateHeader>
          <RateDelivery onSubmit={handleRatingFormSubmit} />
        </div>
      </Container>
    );
  }

  return (
    <Container>
      {isMobile() && <Icon icon="chevron-down" width={20} height={20} onClick={toggleCardOpen} />}

      <React.Fragment>
        <LottieContainer>
          <Lottie options={defaultOptions} height={400} width={400} />
        </LottieContainer>

        <Header>{TITLE[type]}</Header>

        <Content>
          {!!date && `${SUBTITLE[type]} on ${format(date, 'Do MMM YYYY')} at ${format(date, 'HH:mm ')}`}
        </Content>

        {hasAlreadyRated ? <RateThankYou /> : <RateExperience onClick={handleRateClick} />}
      </React.Fragment>
    </Container>
  );
};

CompletedCardBody.propTypes = {
  orderId: PropTypes.string.isRequired,
  companyName: PropTypes.string.isRequired,
  kind: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  onToggleOpenCard: PropTypes.func.isRequired,
  type: PropTypes.oneOf([PICKUP, DROPOFF, RETURN]).isRequired,
};

export default CompletedCardBody;



// WEBPACK FOOTER //
// ./src/app/order-card/completed/body/CompletedCardBody.js